var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPammTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "753e335a-2f5c-4609-9372-e63f531c9954"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "af18f7a7-0ec9-40ca-8ced-52cf5da23473"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.55 0 0 12.55 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.28 -27.72)",
    id: "Path_30942"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-119.74, -52.51)",
    d: "M 116.323 57.205 L 123.14999999999999 57.205 C 123.84045654473145 57.20610999869119 124.40169463156121 56.648449525163926 124.40499999999999 55.958 L 124.40499999999999 54.348 C 124.40499999999999 53.83188990128312 123.98661009871687 53.4135 123.47049999999999 53.4135 C 122.95438990128311 53.4135 122.53599999999999 53.83188990128312 122.53599999999999 54.348 L 122.53599999999999 55.336999999999996 L 116.93599999999999 55.336999999999996 L 116.93599999999999 49.69 L 120.978 49.69 C 121.49411009871687 49.69 121.9125 49.27161009871688 121.9125 48.7555 C 121.9125 48.23938990128312 121.49411009871687 47.821 120.978 47.821 L 116.32199999999999 47.821 C 115.63154345526853 47.819890001308806 115.07030536843875 48.37755047483607 115.067 49.068 L 115.067 55.957 C 115.07030613424456 56.647840605981386 115.63215348214916 57.205661977666935 116.323 57.204 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.28 -9.77)",
    id: "Path_30943"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-119.74, -167.81)",
    d: "M 116.315 172.5 L 123.16199999999999 172.5 C 123.84991825582738 172.49944856225468 124.40744856225469 171.94191825582737 124.40799999999999 171.254 L 124.40799999999999 164.362 C 124.40744856225469 163.6740817441726 123.84991825582738 163.1165514377453 123.16199999999999 163.11599999999999 L 116.315 163.11599999999999 C 115.62708174417261 163.1165514377453 115.0695514377453 163.6740817441726 115.069 164.362 L 115.069 171.254 C 115.0695514377453 171.94191825582737 115.62708174417261 172.49944856225468 116.315 172.5 Z M 116.938 164.985 L 122.538 164.985 L 122.538 170.631 L 116.938 170.631 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.28 8.18)",
    id: "Path_30944"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-119.74, -283.11)",
    d: "M 116.315 287.8 L 123.16199999999999 287.8 C 123.84991825582736 287.7994485622547 124.40744856225467 287.2419182558274 124.40799999999999 286.55400000000003 L 124.40799999999999 279.66200000000003 C 124.40744856225467 278.9740817441727 123.84991825582736 278.41655143774534 123.16199999999999 278.41600000000005 L 116.315 278.41600000000005 C 115.62708174417263 278.41655143774534 115.06955143774532 278.9740817441727 115.069 279.66200000000003 L 115.069 286.55400000000003 C 115.06955143774532 287.2419182558274 115.62708174417263 287.7994485622547 116.315 287.8 Z M 116.938 280.285 L 122.538 280.285 L 122.538 285.93100000000004 L 116.938 285.93100000000004 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.28 26.14)",
    id: "Path_30945"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-119.74, -398.41)",
    d: "M 116.315 403.1 L 123.16199999999999 403.1 C 123.84991825582736 403.09944856225474 124.40744856225467 402.5419182558274 124.40799999999999 401.85400000000004 L 124.40799999999999 394.96200000000005 C 124.40744856225467 394.2740817441727 123.84991825582736 393.71655143774535 123.16199999999999 393.71600000000007 L 116.315 393.71600000000007 C 115.62708174417263 393.71655143774535 115.06955143774532 394.2740817441727 115.069 394.96200000000005 L 115.069 401.85400000000004 C 115.06955143774532 402.5419182558274 115.62708174417263 403.09944856225474 116.315 403.1 Z M 116.938 395.58500000000004 L 122.538 395.58500000000004 L 122.538 401.23100000000005 L 116.938 401.23100000000005 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.27 -30.23)",
    id: "Path_30946"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-219.62, -56.78)",
    d: "M 207.606 57.71 L 231.639 57.71 C 232.15511009871688 57.71 232.5735 57.29161009871688 232.5735 56.7755 C 232.5735 56.25938990128312 232.15511009871688 55.841 231.639 55.841 L 207.606 55.841 C 207.08988990128313 55.841 206.6715 56.25938990128312 206.6715 56.7755 C 206.6715 57.29161009871688 207.08988990128313 57.71 207.606 57.71 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.27 -25.06)",
    id: "Path_30947"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-219.62, -89.98)",
    d: "M 207.606 90.912 L 231.639 90.912 C 232.15511009871688 90.912 232.5735 90.49361009871689 232.5735 89.9775 C 232.5735 89.46138990128313 232.15511009871688 89.043 231.639 89.043 L 207.606 89.043 C 207.08988990128313 89.043 206.6715 89.46138990128313 206.6715 89.9775 C 206.6715 90.49361009871689 207.08988990128313 90.912 207.606 90.912 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.27 -12.3)",
    id: "Path_30948"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-219.62, -171.91)",
    d: "M 207.606 172.843 L 231.639 172.843 C 232.15511009871688 172.843 232.5735 172.42461009871687 232.5735 171.9085 C 232.5735 171.3923899012831 232.15511009871688 170.974 231.639 170.974 L 207.606 170.974 C 207.08988990128313 170.974 206.6715 171.3923899012831 206.6715 171.9085 C 206.6715 172.42461009871687 207.08988990128313 172.843 207.606 172.843 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.27 -7.13)",
    id: "Path_30949"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-219.62, -205.11)",
    d: "M 207.606 206.045 L 231.639 206.045 C 232.15511009871688 206.045 232.5735 205.62661009871687 232.5735 205.1105 C 232.5735 204.5943899012831 232.15511009871688 204.176 231.639 204.176 L 207.606 204.176 C 207.08988990128313 204.176 206.6715 204.5943899012831 206.6715 205.1105 C 206.6715 205.62661009871687 207.08988990128313 206.045 207.606 206.045 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.27 5.62)",
    id: "Path_30950"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-219.62, -287.04)",
    d: "M 207.606 287.977 L 231.639 287.977 C 231.97268607753765 287.9770000248451 232.28102473914572 287.7989806359711 232.44786778508671 287.51000002007515 C 232.6147108310277 287.22101940417923 232.6147108310277 286.8649805958207 232.44786778508671 286.5759999799248 C 232.28102473914572 286.2870193640289 231.97268607753765 286.10899997515486 231.639 286.109 L 207.606 286.109 C 207.0898899012831 286.109 206.67149999999998 286.52738990128313 206.67149999999998 287.0435 C 206.67149999999998 287.55961009871686 207.0898899012831 287.978 207.606 287.978 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.27 10.79)",
    id: "Path_30951"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-219.62, -320.24)",
    d: "M 207.606 321.179 L 231.639 321.179 C 232.1551100987169 321.179 232.57350000000002 320.7606100987168 232.57350000000002 320.24449999999996 C 232.57350000000002 319.7283899012831 232.1551100987169 319.30999999999995 231.639 319.30999999999995 L 207.606 319.30999999999995 C 207.0898899012831 319.30999999999995 206.67149999999998 319.7283899012831 206.67149999999998 320.24449999999996 C 206.67149999999998 320.7606100987168 207.0898899012831 321.179 207.606 321.179 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.17 23.55)",
    id: "Path_30952"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-214.18, -402.18)",
    d: "M 207.606 403.11 L 220.763 403.11 C 221.09668607753764 403.11000002484514 221.40502473914572 402.9319806359711 221.5718677850867 402.6430000200752 C 221.7387108310277 402.35401940417927 221.7387108310277 401.99798059582076 221.5718677850867 401.70899997992484 C 221.40502473914572 401.4200193640289 221.09668607753764 401.2419999751549 220.763 401.242 L 207.606 401.242 C 207.0898899012831 401.242 206.67149999999998 401.66038990128317 206.67149999999998 402.17650000000003 C 206.67149999999998 402.6926100987169 207.0898899012831 403.11100000000005 207.606 403.11100000000005 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.24 28.72)",
    id: "Path_30953"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-214.11, -435.38)",
    d: "M 207.606 436.312 L 220.62099999999998 436.312 C 221.13711009871687 436.312 221.5555 435.89361009871686 221.5555 435.3775 C 221.5555 434.86138990128313 221.13711009871687 434.443 220.62099999999998 434.443 L 207.606 434.443 C 207.0898899012831 434.443 206.67149999999998 434.86138990128313 206.67149999999998 435.3775 C 206.67149999999998 435.89361009871686 207.0898899012831 436.312 207.606 436.312 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.73 -30.06)",
    id: "Path_30954"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-137.65, -41.14)",
    d: "M 134.734 42.02 C 134.30818845788048 41.72839365208934 133.72660634791066 41.83718845788046 133.435 42.263 C 133.14339365208934 42.68881154211954 133.25218845788046 43.27039365208934 133.678 43.562000000000005 L 135.835 45.039 L 135.911 45.073 C 136.06818027360436 45.14375913242897 136.2386270377072 45.18023473994698 136.411 45.18 C 136.84226389419098 45.180752290214734 137.2426312547529 44.956303921414865 137.467 44.588 L 141.83800000000002 38.609 C 142.04500297552346 38.33996208665263 142.08973936951602 37.9797940147468 141.95484547750786 37.66828916953127 C 141.8199515854997 37.35678432431574 141.52666782599263 37.142992319373526 141.18882752508637 37.109893047819114 C 140.8509872241801 37.076793776264694 140.52178678143875 37.22959905584203 140.32900000000004 37.509 L 136.26400000000004 43.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "Path_30955"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-108.67, -48.3)",
    d: "M 85.541 86.609 L 119.561 86.609 C 120.68712472115506 86.60898511523384 121.76298837508222 86.14272926521426 122.533 85.321 L 134.773 72.178 C 135.4602379547345 71.44340218011284 135.84240050762213 70.47494721680826 135.84199999999998 69.469 L 135.84199999999998 14 C 135.82878119202266 11.780336748035468 134.02068263773904 9.990583167947747 131.801 10 L 85.541 10 C 83.32131736226094 9.99058316794775 81.51321880797732 11.78033674803547 81.5 14 L 81.5 82.611 C 81.51431700467869 84.82988054114922 83.32209326718908 86.618420382158 85.541 86.609 Z M 121.82 83.344 L 121.61999999999999 71.92999999999999 L 132.82 71.52999999999999 Z M 83.369 14 C 83.38218717251583 12.812319111077436 84.3542927592159 11.859449852139951 85.542 11.870000000000001 L 131.8 11.870000000000001 C 132.988096096479 11.858894808430184 133.96081348146762 12.811925181027135 133.974 14 L 133.974 69.468 C 133.974 69.51700000000001 133.974 69.568 133.96699999999998 69.61500000000001 L 121.00599999999999 70.08200000000001 C 120.63833274773049 70.0764992850847 120.2868645388271 70.2330324728169 120.04499999999999 70.51 C 119.81461290177492 70.77048335884821 119.70557647539763 71.11649228521878 119.74499999999999 71.462 L 119.972 84.699 C 119.83559795018195 84.7256659713513 119.69698282429383 84.73939355628225 119.55799999999999 84.74 L 85.541 84.74 C 84.35329275921589 84.75055014786004 83.38118717251582 83.79768088892256 83.368 82.61 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPammTwo);
export default __webpack_public_path__ + "static/media/pamm-two.fc9cb823ab9ccb73c41ef68beadadcb0.svg";
export { ForwardRef as ReactComponent };